import { render, staticRenderFns } from "./UserMultiselectField.vue?vue&type=template&id=c94c9f60&scoped=true"
import script from "./UserMultiselectField.vue?vue&type=script&lang=js"
export * from "./UserMultiselectField.vue?vue&type=script&lang=js"
import style0 from "./UserMultiselectField.vue?vue&type=style&index=0&id=c94c9f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94c9f60",
  null
  
)

export default component.exports